(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mobile-menu"] && !Shopify.designMode) return;
  try {
    (function() {
    const menu = document.querySelector('[data-mobile-menu]');
    if (!menu) return;

    const openBtns = document.querySelectorAll('[data-mobile-menu-open]');
    const closeBtns = document.querySelectorAll('[data-mobile-menu-close]');

    function syncLinksFromFooter() {
      const linkKeys = ['tiktok', 'instagram', 'contact'];

      linkKeys.forEach(function(linkKey) {
        const footerLink = document.querySelector('[data-footer-link="' + linkKey + '"]');
        const mobileLink = menu.querySelector('[data-mobile-footer-link="' + linkKey + '"]');

        if (!footerLink || !mobileLink) return;

        mobileLink.href = footerLink.getAttribute('href');
        mobileLink.textContent = footerLink.textContent;
      });
    }

    function open() {
      menu.classList.remove('translate-x-full');
      menu.classList.add('translate-x-0');
      menu.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      menu.classList.remove('translate-x-0');
      menu.classList.add('translate-x-full');
      menu.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    openBtns.forEach(function(btn) { btn.addEventListener('click', open); });
    closeBtns.forEach(function(btn) { btn.addEventListener('click', close); });
    syncLinksFromFooter();
  })();
  } catch(e) { console.error(e); }
})();

})();
